module.exports = __webpack_public_path__ + "img/penilaian-btp-smk.ad1fe4f8.png";